import { Title, Text, SelectorOptionsContainer, SelectorOption } from "../styles";
import { useDeviceType } from "../hooks/useDeviceType";

import { iconMap } from "../../assets/icons";

const Client = () => {
  const device = useDeviceType()
  const mobileLink = device === "Android" ? "https://play.google.com/store/apps/details?id=com.mitre.experience&pli=1" : "https://apps.apple.com/br/app/mitre-experience/id1543244752";
  const mobileIcon = device === "Android" ? "google-play-store" : "apple-mac";
  const mobileMessage = device === "Android" ? "Encontre nosso app na Google Play Store" : "Encontre nosso app na App Store";

  const items = [
    { title:"Atendimento ao Cliente Mitre", text:"Acesso ao portal do cliente", icon:"person", link:"https://portal.mitrerealty.com.br/Clientes/", },
    { title:"Baixe o Aplicativo Mitre Experience", text:mobileMessage, icon:mobileIcon, link:mobileLink },
  ];

  const mobileItems = [
    { title:"Baixe o Aplicativo Mitre Experience no Android", text:"Encontre nosso app na Google Play Store", icon:"google_play_store", link:"https://play.google.com/store/apps/details?id=com.mitre.experience&pli=1" },
    { title:"Baixe o Aplicativo Mitre Experience no IOS", text:"Encontre nosso app na App Store", icon:"apple_mac", link:"https://apps.apple.com/br/app/mitre-experience/id1543244752" }
  ];

  function isInMobileItemButInDesktop(index:number) {
    const itemIndex = 1;
    return index === itemIndex && device === "Unknown";
  }

  return (
    <div>

      <Title>
        Central de Relacionamento
      </Title>

      <Text>
        <>
          Já é cliente Mitre Reality? Precisa falar conosco?
          <br/><br/>
          Acesse o Portal do Cliente para enviar sua solicitação à nossa Central de Relacionamento:  
        </>
      </Text>

      <SelectorOptionsContainer>
        <>
          { items.map((item, index) => (
            <a 
              key={ item.title } 
              href={ item.link }
              target="_blank" rel="noreferrer"
              style={isInMobileItemButInDesktop(index) ? { display:"none" } : {}}
            >
              <SelectorOption>
                <div>
                  <h3>{ item.title }</h3>
                  <p>{item.text}</p>
                </div>
                <img
                  alt=""
                  aria-hidden="true"
                  height={ 26 }
                  src={iconMap[item.icon]}
                  width={ 26 }
                />
              </SelectorOption>
            </a>
          ))}

          { device === "Unknown" &&
            mobileItems.map((item) => (
              <a 
                key={ item.title } 
                href={ item.link }
                target="_blank" rel="noreferrer"
              >
                <SelectorOption>
                  <div>
                    <h3>{ item.title }</h3>
                    <p>{item.text}</p>
                  </div>
                  <img
                    alt=""
                    aria-hidden="true"
                    height={ 26 }
                    src={iconMap[item.icon]}
                    width={ 26 }
                  />
                </SelectorOption>
              </a>
            ))
          }

        </>
      </SelectorOptionsContainer>

    </div>
  )
}

export default Client;
